// extracted by mini-css-extract-plugin
export var column = "legal-documents-column-module--column--0b706";
export var didomiButton = "legal-documents-column-module--didomiButton--6b017";
export var link = "legal-documents-column-module--link--312f9";